export enum CreatedDateFilterEnum {
  ALL = "all",
  D1 = "1d",
  D7 = "7d",
  D30 = "30d",
}
